var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMishpati(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.87 75.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#20b1d3;}.cls-2{fill:#4ab2e5;}.cls-3{fill:#221f1f;fill-rule:evenodd;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,37.51c0-7.93,0-15.87,0-23.8C.06,5.38,6.35-.08,15.19,0,28.56.13,41.77,2,55.05,3.08c2.89.24,5.8.41,8.69.75,6.59.79,11.88,5.89,12,12.17.19,14.34.23,28.69,0,43C75.63,64.43,71,70.68,63.54,71.28Q47.6,72.55,31.68,74.14c-6.68.67-13.38,1.36-20.06.57A13.13,13.13,0,0,1,0,62.23C0,54,0,45.75,0,37.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.42,37.53c0-7.93,0-15.85,0-23.78,0-8.33,6-13.79,14.29-13.7,12.59.13,25,2,37.54,3.07,2.73.24,5.46.41,8.18.76A12.67,12.67,0,0,1,75.72,16c.18,14.33.22,28.66,0,43A12.78,12.78,0,0,1,64.26,71.27q-15,1.28-30,2.86c-6.3.67-12.6,1.36-18.9.57A12.82,12.82,0,0,1,4.46,62.23c-.09-8.23,0-16.47,0-24.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.8,16.21,61,59.56a1.54,1.54,0,0,1-1,2.35c-4.94,1.54-6.15-2.66-7.88-5.15L38,32.74a.47.47,0,0,0-.82,0c-.49.52-8.95,8.5-8.95,8.5-4.07,4.15-8.82,2.32-7.71,0l6.73-9.94c5.17-7.93-.58-6.49-.9-17.19a2.42,2.42,0,0,1,2.89-2.73s5.18,1.1,7.3,1.46C39.4,13.18,40.8,16.21,40.8,16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.92,33.41,44.45,31.2l-15,8.85-.2.13A2.24,2.24,0,0,0,32,43.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.79,31.3h0a1.08,1.08,0,0,0-1.5-.31l-.55.36-5.9,3.93-.55.36a1.08,1.08,0,0,0-.3,1.5v0C50.24,39,59,33.19,57.79,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51,21.13l0,0c-1.25-1.88-10.05,4-8.8,5.85v0a1.09,1.09,0,0,0,1.5.3l.55-.36L50.18,23l.55-.36A1.08,1.08,0,0,0,51,21.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.47,
    y: 25.34,
    width: 9.08,
    height: 7.57,
    transform: "translate(-7.76 32.62) rotate(-33.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.92,38l4.13,6.8a2,2,0,0,1-.26,2.14l-11.62,15c-2.71,3.79-7-.42-3.69-5.7,0,0,9.45-17.42,9.76-18.05A.91.91,0,0,1,37.92,38Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMishpati);
export default __webpack_public_path__ + "static/media/mishpati.3bc00bd12dac84af28b9cfce8cbffe4f.svg";
export { ForwardRef as ReactComponent };